<template>
  <div>
    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
    >
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column prop="rowNum" label="序号" align="center"></el-table-column>
      <el-table-column prop="courseName" label="课程代码及名称" align="center">
      </el-table-column>
      <el-table-column
        prop="majorName"
        label="专业"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="admissionCard"
        label="准考证号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="examLocationName"
        label="考点名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="examLocationAddress"
        label="考点地址"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="examTimeStr"
        label="考试时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="roomName"
        label="试室"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="seatNumber"
        label="座位号"
        align="center"
      ></el-table-column>
      <!-- <el-table-column
        prop="uname"
        label="操作"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table_control">
            <span
              class="table_control_item"
              @click="
                lookCard(scope.row.vid, scope.row.courseName, scope.row.id)
              "
              >查看</span
            >
          </div>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>

    <!-- 打印弹窗 -->
    <el-dialog
      title="预览准考证"
      :visible.sync="dialogVisible"
      width="890px"
      @close="cancel"
    >
      <div ref="printCount">
        <!-- 背景图 -->
        <div class="img-bg">
          <img class="bg" src="@/static/images/card-bg.png" alt="" />
          <div class="title">2022年3月华南理工大学高等教育自学考试</div>
          <div class="card">准考证</div>
          <el-table
            :show-header="false"
            :data="tableData2"
            :span-method="objectSpanMethods"
            :cell-style="rowStyle"
            style="margin-top: 0;z-index:9999;background-color:rgba(255, 255, 255,.4)"
            border
          >
            <el-table-column width="180" prop="name"></el-table-column>
            <el-table-column prop="amount1"></el-table-column>
            <el-table-column width="180" prop="amount2"></el-table-column>
            <el-table-column prop="amount3"></el-table-column>
            <el-table-column prop="id" label="ID" width="160">
              <template slot-scope="scope">
                <div>
                  <img class="avatar" :src="scope.row.id" />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-table
          :data="tableDatas"
          :span-method="objectSpanMethod"
          :cell-style="rowStyle"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="name" align="center" label="考试时间">
          </el-table-column>
          <el-table-column prop="amount1" align="center" label="课程代码及名称">
          </el-table-column>
          <el-table-column prop="amount2" align="center" label="试室">
          </el-table-column>
          <el-table-column prop="amount3" align="center" label="座位号">
          </el-table-column>
        </el-table>
        <el-table
          :data="tableDatas1"
          :span-method="objectSpanMethod"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="name" label="注意事项"> </el-table-column>
        </el-table>
      </div>

      <!-- 操作部分 -->
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center"
      >
        <!-- <el-button type="primary" @click="printCard"> 打印 </el-button> -->
        <el-button @click="cancel">返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from "@/api/MyAdmitCard/index";
export default {
  data() {
    return {
      dialogVisible: false,
      tableData2: [
        {
          id: "https://img2.baidu.com/it/u=428561421,1547551643&fm=253&fmt=auto&app=138&f=PNG?w=388&h=500",
          name: "准考证号",
          amount1: 25,
          amount2: "身份证号",
          amount3: "3607821975846245x",
        },
        {
          id: 54,
          name: "姓名",
          amount1: "赵小雨",
          amount2: "专业",
          amount3: "计算机网络",
        },
        {
          name: "考点名称",
          amount2: "华南理工大学（五三校区）",
        },
        {
          name: "考点地址",
          amount2: "广州市",
        },
      ],
      tableDatas: [
        {
          name: "2022-04-28 00:00-12:00",
          amount1: "0234-色彩",
          amount2: "科学院801",
          amount3: "科学院802",
        },
        {
          name: "2022-03-18 09:00-13:00",
          amount1: "0624-色彩",
          amount2: "研究院504",
          amount3: "研究院307",
        },
      ],
      tableDatas1: [
        {
          name: "1.考前30分钟凭本准考证、有效身份证参加考试;开考15分钟后禁止进入考场;交卷出场不得早于考试开始后1小时，出场后不得再进入考场。",
        },
        {
          name: "2.除必要文具外，其他任何物品不得带入考场。3.考生领取试卷后须仔细核对试卷课程是否正确、有无缺页、缺题、字迹不清等现象，如有须立即向监考员报告。",
        },
        {
          name: "3.考生领取试卷后须仔细核对试卷课程是否正确、有无缺页、缺题、字迹不清等现象，如有须立即向监考员报告。",
        },
        {
          name: "4.考生参加考试时应严格遵守《广东省高等教育自学考试考场规则》",
        },
        {
          name: "5.本准考证用普通A4纸打印，严禁伪造、变造或擅自涂改。",
        },
      ],
      tableData: [],
      // 分页
       //   分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      selectedList: [],
    };
  },
  computed: {
    getUId() {
      return localStorage.getItem("uid");
    },
    url() {
      let url = window.location.protocol + "//" + window.location.host;
      if (window.location.host == "localhost:5001") {
        url = "http://gz.hnjk.net";
      }
      return url;
    },
  },
  created() {
    this.getPageByStudentId();
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.enterQuery);
  },
  methods: {
    async getPageByStudentId() {
      console.log("backd222t", this.$route.query.courseId);

        const { data, code } = (
          await api.getPageByStudentId({
            uid: localStorage.getItem("uid"),
            examStatus: "1",
            ...this.pageObj,
          })
        ).data
        if (code === 100000) {
          this.tableData = data.page.list;
          console.log("11223",this.tableData);
          this.total = data.page.total
        }
    },

    enterQuery(e) {
      if (e.key === "Enter") {
        this.search();
      }
    },
    // 删除
    delAll() {
      this.$refs.form.resetFields();
      this.pageObj.page = 1;
      this.getPageByStudentId();
    },
    addStudents() {
      this.$emit("addStudents");
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val;
      this.getPageByStudentId();
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val;
      this.getPageByStudentId();
    },
    // 下拉改变触发
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur();
      }
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr;
    },
    goLearningOutcome() {
      this.$emit("goLearningOutcomeFromStudent");
    },
    sortChange({ column, prop, order }) {},
    // 回复弹窗
    replay() {
      this.dialogVisible = true;
    },
    deleteAswer() {},
    // 返回
    cancel() {
      this.dialogVisible = false;
    },
    // 表格中间部分
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
     
    },
    // 合并表格rowIndex(行)、columnIndex（列）
    objectSpanMethods({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 2 || rowIndex === 3) {
        if (columnIndex === 2) {
          return [1, 3];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
      if (columnIndex === 4) {
        if (rowIndex % 5 === 0) {
          return {
            rowspan: 5,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    // 属性居中显示
    rowStyle() {
      return "text-align:center";
    },
    // 查看准考证
    lookCard() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/classManagement.scss";
.table_control {
  color: #409eff;
  .table_control_item {
    cursor: pointer;
  }
}
/deep/.el-dialog__header {
  background-color: #d7d7d7;
}
// /deep/ .el-table .cell {
//   font-size: 18px;
//   color: #000000;
// }
.img-bg {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.bg {
  position: absolute;
  left: -105px;
  top: -79px;
  z-index: 9999;
  width: 300px;
  height: 300px;
  opacity: 0.4;
}
.title {
  width: 100%;
  border-top: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  padding-top: 10px;
  padding-bottom: 5px;
  text-align: center;
  font-size: 22px;
}
.card {
  width: 100%;
  border-right: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  padding-bottom: 10px;
  text-align: center;
  font-size: 26px;
  color: #000000;
  font-weight: 600;
}
.avatar {
  width: 100%;
  height: 100%;
}
/deep/ .el-table tr{
  background-color: rgba($color: #FFFFFF, $alpha: 0.2);
}
// /deep/.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
//     border-bottom: 0px solid #EBEEF5;
// }
// /deep/.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
//     border-bottom: 0px solid #EBEEF5;
// }
</style>

